import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../ghs-icon/ghs-icon';
import componentStyles from './ghs-newco-link.css.lit';
import { LightController } from '../../controllers/light-controller';
import { OutlineElement } from '../../base/outline-element/outline-element';

/**
 * The Newco Link component
 * @slot - The default, and only slot for this element.
 */
@customElement('ghs-newco-link')
export class GhsNewcoLink extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  lightController = new LightController(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  /**
   * Icon name for ghs-icon component
   * @param icon
   */
  @property({ type: String, attribute: 'icon' })
  icon: string;

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}
